export const THREE_D_VARIANTS = [
    { id: 'bar3d', label: '3D Bar Chart', icon: 'fas fa-cube' },
    { id: 'ring3d', label: '3D Ring Gauge', icon: 'fas fa-circle-notch' },
    { id: 'sphere3d', label: '3D Capacity Sphere', icon: 'fas fa-globe' },
    { id: 'tower3d', label: '3D Tower Meter', icon: 'fas fa-chart-bar' },
    { id: 'cylinder3d', label: '3D Tank Level', icon: 'fas fa-database' },
    { id: 'cone3d', label: '3D Cone Meter', icon: 'fas fa-filter' },
    { id: 'pyramid3d', label: '3D Pyramid Stack', icon: 'fas fa-layer-group' },
    { id: 'helix3d', label: '3D Helix Coil', icon: 'fas fa-dna' },
    { id: 'pie3d', label: '3D Pie Chart', icon: 'fas fa-chart-pie' },
    { id: 'crystal3d', label: '3D Crystal Gem', icon: 'fas fa-gem' },
    { id: 'battery3d', label: '3D Battery Cell', icon: 'fas fa-battery-three-quarters' },
    { id: 'wave3d', label: '3D Liquid Wave', icon: 'fas fa-water' },
    { id: 'turbine3d', label: '3D Wind Turbine', icon: 'fas fa-fan' },
    { id: 'solar3d', label: '3D Solar Array', icon: 'fas fa-solar-panel' },
    { id: 'radar3d', label: '3D Radar Sweep', icon: 'fas fa-satellite-dish' },
    { id: 'orb3d', label: '3D Energy Orb', icon: 'fas fa-atom' },
    { id: 'network3d', label: '3D Meter Network', icon: 'fas fa-diagram-project' },
    { id: 'flow3d', label: '3D Power Flow', icon: 'fas fa-right-left' },
    { id: 'meter-grid3d', label: '3D Meter Grid', icon: 'fas fa-border-all' },
];
